module.exports = __webpack_public_path__ + "img/p5img1_en.64fbb5ff.png";